export const FormType = {
  Create: "create",
  Edit: "edit",
};
